import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import "../../css/DLT.css";
import { apiList } from "../../helpers/apiList";
import { axiosPostApi } from "../../helpers/interceptorServices";
import Pagination from "../common/Pagination";
import { BiEditAlt } from "react-icons/bi";
import { RiDeleteBinLine } from "react-icons/ri";
import { IoEyeOutline } from "react-icons/io5";
import SenderIDModal from "./SenderIDModal";
import DeleteConfirmationDltModal from "./DeleteConfirmationDltModal";
import { toast } from "react-toastify";
import CustomAlert from "../../helpers/CustomAlert";
import { useSelector } from "react-redux";
import { Popover, Transition } from "@headlessui/react";
import {isOperationRole} from "../../utils";

const SenderIDs = ({ openModal, customerCode, name }) => {
  const loggedInUserName = sessionStorage.getItem("username");
  const [showTable, setShowTable] = useState(false);
  const [loading, setLoading] = useState(false);
  const [senders, setSenders] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize] = useState(10);
  const [openPopup, setOpenPopup] = useState(false);
  const [selectedSender, setSelectedSender] = useState(null);
  const [modalType, setModalType] = useState("");
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deletedId, setDeletedId] = useState(null);
  const { user } = useSelector((state) => state.auth);

  const handleViewSender = (sender, type) => {
    setSelectedSender({
      name: sender?.sendorName,
      id: sender?.sendorId,
      customerCode: sender?.customerCode,
      entityId: sender?.entityId,
    });
    setModalType(type);
    setOpenPopup(true);
  };

  const handleClose = () => {
    setOpenPopup(false);
    setOpenDeleteModal(false);
  };

  const handleShowTable = async () => {
    setShowTable(true);
    setLoading(true);
    await fetchSenderData(1);
  };

  const fetchSenderData = async (page) => {
    const data = {
      username: loggedInUserName,
      customerCode: customerCode,
    };

    try {
      const response = await axiosPostApi(
        `${apiList.DLT_FETCH_SENDER}?pageSize=${pageSize}&pageNo=${page}`,
        data
      );
      setSenders(response?.data?.data || []);
      setPageDetails(response?.data?.pageDetails || null);
    } catch (error) {
      console.error("Failed to fetch sender data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSwitch = () => {
    openModal();
    setShowTable(false);
  };

  const handleDeleteId = (sender) => {
    setDeletedId({
      username: loggedInUserName,
      customerCode: sender?.customerCode,
      sendorId: sender?.sendorId,
      status: "3",
    });
    setOpenDeleteModal(true);
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await axiosPostApi(apiList.DELETE_SENDORID, deletedId);
      if (response?.status === 200 && response.data.status === true) {
        toast.success("Sender Deleted Successfully!", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        handleClose();
        await handleShowTable();
      } else if (response.data.respCode === "01") {
        CustomAlert({
          title: "Data Submission Error",
          text: response.data.message || "Please check the details and try again.",
          icon: "error",
          confirmButtonText: "Retry",
        });
        handleClose();
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while deleting the sender. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const getActionItems = (sender) => {
    const actions = [];

    if (!isOperationRole()) {
      actions.push({
        icon: <BiEditAlt style={{ marginRight: "10px" }} />,
        label: "Edit",
        onClick: (e) => {
          e.stopPropagation();
          handleViewSender(sender, "modify");
        },
      });
    }

    actions.push({
      icon: <IoEyeOutline style={{ marginRight: "10px" }} />,
      label: "View",
      onClick: (e) => {
        e.stopPropagation();
        handleViewSender(sender, "view");
      },
    });

    if (!isOperationRole()) {
      actions.push({
        icon: <RiDeleteBinLine style={{ marginRight: "10px" }} />,
        label: "Delete",
        onClick: (e) => {
          e.stopPropagation();
          handleDeleteId(sender);
        },
      });
    }

    return actions;
  };

  return (
    <div className="sender-ids-container">
      <div className="d-flex first-tab-controls">
        <div className="d-flex gap-3"></div>
        <div className="d-flex gap-3">
          <button
            className="btn addUser"
            onClick={handleShowTable}
            disabled={showTable}
            style={{
              backgroundColor: showTable ? "#80d7e1" : "",
              color: showTable ? "#ffffff" : "",
            }}
          >
            Show Sender ID
          </button>
          {!isOperationRole() && (
            <button className="btn addUser" onClick={handleSwitch}>
              + Add Sender ID
            </button>
          )}
        </div>
      </div>

      {loading ? (
        <div className="loading-container">
          <CircularProgress />
        </div>
      ) : (
        showTable && (
          <div className="table-container">
            {senders.length > 0 ? (
              <>
                <div className="table-wrapper">
                  <table className="custom-table">
                    <thead>
                      <tr>
                        <th>Action</th>
                        <th>Status</th>
                        <th>Sender ID</th>
                        <th>Sender Name</th>
                        <th>Entity ID</th>
                        <th>Created Date-Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      {senders.map((sender) => (
                        <tr key={sender.sendorId}>
                          <td className="actions" style={{ overflow: "visible" }}>
                            <Popover>
                              {({ open, close }) => (
                                <>
                                  <Popover.Button
                                    style={{
                                      cursor: "pointer",
                                      fontSize: "20px",
                                      display: "inline-block",
                                      padding: "0 10px",
                                      background: "none",
                                      border: "none",
                                    }}
                                  >
                                    ⋮
                                  </Popover.Button>
                                  <Transition
                                    as={React.Fragment}
                                    enter="transition ease-out duration-200"
                                    enterFrom="opacity-0 translate-y-1"
                                    enterTo="opacity-100 translate-y-0"
                                    leave="transition ease-in duration-150"
                                    leaveFrom="opacity-100 translate-y-0"
                                    leaveTo="opacity-0 translate-y-1"
                                  >
                                    <Popover.Panel
                                      style={{
                                        position: "absolute",
                                        zIndex: 2000,
                                        minWidth: "220px",
                                        backgroundColor: "#ffffff",
                                        boxShadow: "0 8px 16px rgba(0,0,0,0.25)",
                                        border: "1px solid #d1d5db",
                                        borderRadius: "8px",
                                        padding: "8px 0",
                                        overflow: "visible",
                                      }}
                                    >
                                      {getActionItems(sender).map((action, idx) => (
                                        <div
                                          key={idx}
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            padding: "10px 20px",
                                            cursor: "pointer",
                                            color: "#333",
                                            fontSize: "15px",
                                            fontWeight: "500",
                                            transition: "background-color 0.2s",
                                            whiteSpace: "nowrap",
                                          }}
                                          onMouseEnter={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#f0f0f0")
                                          }
                                          onMouseLeave={(e) =>
                                            (e.currentTarget.style.backgroundColor = "#ffffff")
                                          }
                                          onClick={(e) => {
                                            action.onClick(e);
                                            close();
                                          }}
                                        >
                                          {action.icon}
                                          <span>{action.label}</span>
                                        </div>
                                      ))}
                                    </Popover.Panel>
                                  </Transition>
                                </>
                              )}
                            </Popover>
                          </td>
                          <td>
                            <span
                              className="status"
                              style={{
                                color:
                                  sender.status === "ACTIVE"
                                    ? "#55cd69"
                                    : sender.status === "BLOCKED"
                                    ? "#fb4a3f"
                                    : "#6c757d",
                              }}
                            >
                              {sender.status || "-"}
                            </span>
                          </td>
                          <td>{sender.sendorId || "-"}</td>
                          <td>{sender.sendorName || "-"}</td>
                          <td>{sender.entityId || "-"}</td>
                          <td>{sender.createdDate || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="mt-3">
                  <Pagination
                    currentPage={currentPage}
                    totalCount={pageDetails?.totalRecords || 0}
                    pageSize={pageSize}
                    onPageChange={(page) => {
                      setCurrentPage(page);
                      fetchSenderData(page);
                    }}
                  />
                </div>
              </>
            ) : (
              <p className="no-data-message">No data available</p>
            )}
          </div>
        )
      )}
      <SenderIDModal
        show={openPopup}
        handleClose={handleClose}
        customerCode={customerCode}
        name={name}
        senderDetails={selectedSender}
        modalType={modalType}
        handleShowTable={handleShowTable}
      />
      <DeleteConfirmationDltModal
        isOpen={openDeleteModal}
        onClose={handleClose}
        handleDelete={handleDelete}
        loading={loading}
      />
    </div>
  );
};

export default SenderIDs;